<script lang="ts">
  interface Props {
    value?: string | null
  }

  let { value }: Props = $props()
</script>

<div class="my-0 box-border flex px-2 text-gray-400 md:min-w-96">
  {value}
</div>
